import actions from "./actions";
import { call, put, takeLatest, fork } from "redux-saga/effects";
import {
  EXCHANGE_CODE,
  OTP_LOG,
  REQUEST_GIGYA,
  REQUEST_LOGIN,
  REQUEST_OTP,
  TOPUP_MOBILE,
  UPDATE_USER_INFO,
  VALIDATE_CAMPAIGN,
  VALIDATE_CODE,
  VERIFY_OTP,
  GET_STORE_BY_PHONE,
  GET_CAMPAIGN_INFO,
  SUBMIT_WISH,
  GET_GIFT_SUMMARY,
  TAKE_GIFT,
  GET_BLOCK_LIST
} from "./constants";
import {
  exchangeCodeApi,
  getBlockListApi,
  getCampaignInfoApi,
  getGiftSummaryApi,
  getStoreByPhoneApi,
  OTPLogApi,
  requestGigyaApi,
  requestLoginApi,
  requestOTPApi,
  submitWishApi,
  takeGiftApi,
  updateUserInfoApi,
  validateCampaignApi,
  validateCodeApi,
  verifyOTPApi,
} from "api/home";

export function* validateCodeSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(validateCodeApi, payload);
    yield put(actions.VALIDATE_CODE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VALIDATE_CODE.failure(err));
  }
}

export function* validateCampaignSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(validateCampaignApi, payload);
    yield put(actions.VALIDATE_CAMPAIGN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VALIDATE_CAMPAIGN.failure(err));
  }
}

export function* requestOTPSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestOTPApi, payload);
    yield put(actions.REQUEST_OTP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_OTP.failure(err));
  }
}

export function* OTPLogSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(OTPLogApi, payload);
    yield put(actions.OTP_LOG.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.OTP_LOG.failure(err));
  }
}

export function* verifyOTPSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(verifyOTPApi, payload);
    yield put(actions.VERIFY_OTP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VERIFY_OTP.failure(err));
  }
}

export function* requestLoginSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestLoginApi, payload);
    yield put(actions.REQUEST_LOGIN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_LOGIN.failure(err));
  }
}

export function* updateUserInfoSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(updateUserInfoApi, payload);
    yield put(actions.UPDATE_USER_INFO.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.UPDATE_USER_INFO.failure(err));
  }
}

export function* requestGigyaSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestGigyaApi, payload);
    yield put(actions.REQUEST_GIGYA.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_GIGYA.failure(err));
  }
}

export function* exchangeCodeSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(exchangeCodeApi, payload);
    yield put(actions.EXCHANGE_CODE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.EXCHANGE_CODE.failure(err));
  }
}


//new
export function* getStoreByPhoneSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getStoreByPhoneApi, payload);
    yield put(actions.GET_STORE_BY_PHONE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_STORE_BY_PHONE.failure(err));
  }
}

export function* getCampaignInfoSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getCampaignInfoApi, payload);
    yield put(actions.GET_CAMPAIGN_INFO.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_CAMPAIGN_INFO.failure(err));
  }
}

export function* submitWishSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(submitWishApi, payload);
    yield put(actions.SUBMIT_WISH.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.SUBMIT_WISH.failure(err));
  }
}

export function* getGiftSummarySaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getGiftSummaryApi, payload);
    yield put(actions.GET_GIFT_SUMMARY.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_GIFT_SUMMARY.failure(err));
  }
}

export function* takeGiftSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(takeGiftApi, payload);
    yield put(actions.TAKE_GIFT.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.TAKE_GIFT.failure(err));
  }
}


export function* getBlockListSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getBlockListApi, payload);
    yield put(actions.GET_BLOCK_LIST.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_BLOCK_LIST.failure(err));
  }
}
function* watchCommon() {
  yield takeLatest(VALIDATE_CODE.request, validateCodeSaga);
  yield takeLatest(VALIDATE_CAMPAIGN.request, validateCampaignSaga);
  yield takeLatest(REQUEST_OTP.request, requestOTPSaga);
  yield takeLatest(OTP_LOG.request, OTPLogSaga);
  yield takeLatest(VERIFY_OTP.request, verifyOTPSaga);
  yield takeLatest(REQUEST_LOGIN.request, requestLoginSaga);
  yield takeLatest(UPDATE_USER_INFO.request, updateUserInfoSaga);
  yield takeLatest(REQUEST_GIGYA.request, requestGigyaSaga);
  yield takeLatest(EXCHANGE_CODE.request, exchangeCodeSaga);
  yield takeLatest(GET_STORE_BY_PHONE.request, getStoreByPhoneSaga);
  yield takeLatest(GET_CAMPAIGN_INFO.request, getCampaignInfoSaga);
  yield takeLatest(SUBMIT_WISH.request, submitWishSaga);
  yield takeLatest(GET_GIFT_SUMMARY.request, getGiftSummarySaga);
  yield takeLatest(TAKE_GIFT.request, takeGiftSaga);
  yield takeLatest(GET_BLOCK_LIST.request, getBlockListSaga);
  
}

export default function* rootChild() {
  yield fork(watchCommon);
}
